<div class="row paddingLeft paddingBottom">
  <prism-ui-form-field-select
    [isValid]="formControlUtilitiesService.isControlValid(parentForm, product.key + '_subProduct')"
    [formFieldItemsCount]="product.subProducts.length"
    keyId="{{product.key + '_subProduct'}}"
    orientation="vertical"
    >
    <span slot="error">Please make a selection.</span>
  </prism-ui-form-field-select>
  @for (sub of product.subProducts; track sub; let index = $index) {
    <div class="alignColaTooltips" id="{{product.key + '_subProduct'}}" formControlName="{{product.key + '_subProduct'}}" slot="input-{{ index + 1 }}">
      <ng-container>
        <prism-ui-radio-button
          labelText="{{sub.displayName}}"
          [keyId]="sub.key"
          ngDefaultControl
          [name]="sub.key + index"
          formControlName="{{ sub.key + index }}"
          [checked]="parentForm.get(product.key + '_subProduct').value === sub.displayName"
          [isValid]="formControlUtilitiesService.isControlValid(parentForm, product.key + '_subProduct')"
          (prismUiRadioButtonOnChange)="subProductRadioSelected(product.key + '_subProduct', sub.displayName)"
          >
        </prism-ui-radio-button>
        @if (sub.displayName.slice(-4) === 'COLA') {
          <div class="toolTipLeftPadding">
            <prism-ui-icon-button
              expanded="false"
              has-tooltip="true"
              icon-name="circle-info"
              is-inactive="false"
              is-waiting="false"
              key-id="{{colaToolTipName}}"
              label="{{colaToolTipDescription}}"
              size="small"
              [tooltipPosition]="colaToolTipPosition"
              type="button"
              variant="tertiary"
              >
              <prism-ui-copy key-id="colaTooltip">{{colaToolTipDescription}}</prism-ui-copy>
            </prism-ui-icon-button>
          </div>
        }
      </ng-container>
    </div>
  }
</div>